import React from "react";
import { SwiperSlide } from "swiper/react";

import { sortTickets } from "../../../utilities/helpers";

import { Slider } from "../../Slider";
import { QRTicketCard } from "../../QRTicketCard";

export default function MyTicketsSlider({ order, event, handleClick }) {
  return (
    <div className="page-slider">
      <Slider addedModule="pagination">
        {order &&
          sortTickets(order.tickets).map((ticket, index) => {
            return (
              <SwiperSlide className="swiper-lazy" key={index}>
                <QRTicketCard
                  ticket={ticket}
                  key={index}
                  order={order}
                  handleClick={handleClick}
                  event={event}
                />
              </SwiperSlide>
            );
          })}
      </Slider>
    </div>
  );
}
